import React, { Component } from 'react';

import { loadData, changeDevice } from './VisState';

import DevicesMap from '../../Component/DevicesMap';
import BarChart from '../../Component/Barchart';
import Sharer from '../../Component/Sharer';

import './Vis.scss';

export default class DevicesVis extends Component {
  constructor(){
    super();

    this.handleDevice = this.handleDevice.bind(this);
  }

  componentDidMount() {
    this.props.dispatch(loadData());
  }

  handleDevice(device) {
    this.props.dispatch(changeDevice(device));
  }

  render() {
    return (
      <div>
        <div className='devicevis--innerWrapper'>
          {!this.props.loading && <BarChart
            key='device-barchart'
            data={this.props.data}
            selectedDevice={this.props.selectedDevice}
            handler={this.handleDevice}
          />}
          {!this.props.loading && <DevicesMap key='devicemap' {...this.props} />}
        </div>
        <Sharer
          url={`${window.config.baseUrl}#geraete-haushalt`}
          title={window.config.labels.devices_vis_sharing_title}
          description={window.config.labels.devices_vis_sharing_text}
          image={`${window.config.baseUrl}assets/images/b1_haushalt_geraete_share.png`}
        />
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/modules/DevicesVis/Vis.js